import { useState } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { LocationFormik } from 'svila-common';
import LocationEdit from '../../scenes/warehouses/movements/pages/LocationEdit';
import { getLocationFromFormik } from '../../utils/misc';
import PrimaryButton from './forms/Button/PrimaryButton';
import SecondaryButton from './forms/Button/SecondaryButton';
import ErrorLabel from './forms/ErrorLabel';
import BorderlessButton from './forms/Button/BorderlessButton';
import xCircle from '../../static/img/xCircle.svg';
import changeLocationIcon from '../../static/img/changeLocationIcon.svg';
import { Colors } from '~/src/scss/common/style';
import ModalWrapper from './Modal';

interface Props {
  setField: (name: string, value: string) => void;
  values: {
    chamberNumber: string;
    column: string;
    letter: string;
    level: string;
  };
  touched?: any;
  errors?: any;
  onClose?: (values: LocationFormik) => void;
}

export default function LocationEditModal({ setField, values, touched, errors, onClose }: Props): JSX.Element {
  const [locationModalVisible, setLocationModalVisible] = useState(false);
  Modal.setAppElement('#root');

  return (
    <Wrapper>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <SecondaryButton
          title="Change Location"
          onClick={(): void => {
            setLocationModalVisible(true);
          }}
          icon={changeLocationIcon}
        />
        <TextWrapper style={{ padding: 10 }}>{getLocationFromFormik(values)}</TextWrapper>
      </div>
      <div>
        {touched &&
          (touched['chamberNumber'] || touched['column'] || touched['letter'] || touched['level']) &&
          (errors['chamberNumber'] || errors['column'] || errors['letter'] || errors['level']) && (
            <ErrorLabel error="Full location is required" />
          )}
      </div>
      <StyledModal isOpen={locationModalVisible} style={{ overlay: { zIndex: 10 } }}>
        <WrapperModal>
          <WrapperCloseBtn>
            <BorderlessButton
              icon={xCircle}
              iconSize={35}
              onClick={(): void => {
                setLocationModalVisible(false);
                if (onClose) {
                  onClose(values);
                }
              }}
            />
          </WrapperCloseBtn>
          <LocationEdit
            setField={setField}
            setModal={setLocationModalVisible}
            chamberNumber={values.chamberNumber}
            column={values.column}
            letter={values.letter}
            level={values.level}
          />
          <FlexSaveButton>
            <PrimaryButton
              onClick={(): void => {
                setLocationModalVisible(false);
                if (onClose) {
                  onClose(values);
                }
              }}
              title="Save"
            />
          </FlexSaveButton>
        </WrapperModal>
      </StyledModal>
    </Wrapper>
  );
}

const WrapperCloseBtn = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9999;
`;

const FlexSaveButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WrapperModal = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
`;

const StyledModal = styled(ModalWrapper)`
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${Colors.white};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: colunn;
  position: relative;
`;

const TextWrapper = styled.div`
  color: ${Colors.darkBrown};
  font-size: 15px;
  font-weight: 700;
`;
